<ng-select [items]="concreteStrengths" autofocus bindLabel="name" bindValue="name" [virtualScroll]="true"
           placeholder="Please Select" [(ngModel)]="concreteStrength" (ngModelChange)="concreteStrengthChanged()" [selectOnTab]="true"
             [addTag]="true"  >

</ng-select>
